import React, { useState } from 'react'
import NavHome from '../../components/navHome/NavHome'
import Waves from '../../components/waves/Waves'
import "./questions.scss"
import {Phrases,LngToNum} from "../../content"
import Back from '../../components/back/Back'
import {useTranslation} from  'react-i18next'

export default function Questions() {
    const {t} = useTranslation(["common"]);

    const [word,setWord] = useState("")
    const NewPhrase = ()=>{
        const rnd = Math.floor(Math.random() * 31)
        const lng = LngToNum(localStorage.getItem("i18nextLng"))
        setWord(Phrases[lng][rnd]);
    }

  return (
    <div className='questions'>
        <NavHome/>
        <Back/>
        <div className="stuff">
            <p className='title'>{t("StartResponse")}</p>
            <h2 className='word'>{word}</h2>
            <div className="buttons">
               <div className="btn">
                    <button className='start  ' onClick={() => { NewPhrase()}}
                    >
                        <span>{t("BtnNewAnswer")}</span> 
                        <div className="liquid"></div>
                    </button>
                </div>
            </div>
        </div>
        <Waves/>
    </div>
  )
}
